<template lang="html">
  <div class="v-scope-home-modulo-ofertas">
    <section class="ofertas-home">
      <template v-if="ofertas.empleo.length != 0 || ofertas.practicas.length != 0">
        <nav class="selector-tipo row-start">
          <!-- <a v-if="!!candidaturas" :active="how == 1" @click="how = 1">Candidaturas</a> -->
          <a :active="(how == 3) ? 'true' : 'false'" @click="how = 3" v-if="ofertas.empleo.length > 0">
            <span class="pc">{{ $t('ofertas.ultimas_empleo') }}</span>
            <span class="mvl">Ofertas empleo</span>
          </a>
          <a :active="(how == 2) ? 'true' : 'false'" @click="how = 2" v-if="ofertas.practicas.length > 0">
            <span class="pc">{{ $t('ofertas.ultimas_practicas') }}</span>
            <span class="mvl">Prácticas</span>
          </a>
        </nav>
        <template v-if="!itsLoader">
          <oferta-el--fake :key="'fake' + key" v-for="(oferta, key) in 4"></oferta-el--fake>
        </template>
        <template v-if="!!candidaturas">
          <div class="ofertas-list" v-show="how == 1">
            <oferta-el v-for="(oferta, key) in candidaturas.practicas.slice(0, 4)" :key="`practicas-${key}`"
              :data="oferta" :type="'practicas'"></oferta-el>
            <oferta-el v-for="(oferta, key) in candidaturas.empleo.slice(0, 4)" :key="`empleo-${key}`" :data="oferta"
              :type="'empleo'"></oferta-el>
            <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.mis_candidaturas')"></arrow-link>
          </div>
        </template>
        <template v-if="!!ofertas">
          <div class="ofertas-list" v-if="ofertas.practicas.length > 0" v-show="how == 2">
            <oferta-el v-for="(oferta, key) in ofertas.practicas.slice(0, 5)" :key="`practicas-${key}`" :data="oferta"
              :type="'practicas'"></oferta-el>
            <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
            <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_practicas')"></arrow-link>
          </div>

          <div class="ofertas-list" v-if="ofertas.empleo.length > 0" v-show="how == 3">
            <oferta-el v-for="(oferta, key) in ofertas.empleo.slice(0, 5)" :key="`empleo-${key}`" :data="oferta"
              :type="'empleo'"></oferta-el>
            <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
            <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_empleo')"></arrow-link>
          </div>

        </template>
      </template>

      <template v-else>
        <div class="sin-ofertas"
          v-if="(params.practicas.numPaginas == 0 || params.empleo.numPaginas == 0) && ofertasloaded">
          <h2>{{ $t('ofertas.ofertas') }}</h2>
          <p>{{ $t('ofertas.zero_ofertas_titulacion') }}</p>
        </div>
        <loading v-else :small="true"></loading>
      </template>

    </section>
  </div>
</template>

<script lang="js">

import { mapGetters } from 'vuex'

import ofertaEl from './oferta-el';
import fakeofertaEl from './oferta-el--fake';

import arrowLink from '@/components/parts/icons/arrow-link';


import loadingView from '@/components/parts/loading';

export default {
  name: 'modulo-ofertas',
  data() {
    return {
      how: 2
    }
  },
  mounted() {
    this.setInitialHow();
  },
  watch: {
    ofertas: {
      handler() {
        this.setInitialHow();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      style: 'getStyles',
      ofertas: 'getOfertas',
      candidaturas: 'getCandidaturas',
      colors: 'basicColors',
      params: 'getParamsOfertas',
      soloCiclosUAX: 'getsoloCiclosUAX',
      ofertasloaded: 'getofertasloaded'
    }),
    itsLoader: function () {
      let flag = true;

      if (this.ofertas.empleo.length == 0 && this.ofertas.practicas.length == 0) {
        if (this.candidaturas.empleo.length == 0 && this.candidaturas.practicas.length == 0) {
          flag = false;
        }
      }

      return flag;
    },
    ownstyles: function () {
      return {
        selectorTipo: {
          'border-top': `4px solid ${(!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic}`,
          'background': `${(!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic}`,
          'color': (!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic
        },
        verTodas: {
          'border-top': `1px solid ${this.colors.soft_black}`
        }
      }
    }
  },
  methods: {
    setInitialHow() {
      if (this.ofertas && this.ofertas.empleo && this.ofertas.empleo.length > 0) {
        this.how = 3;
      } else {
        this.how = 2;
      }
    }
  },
  components: {
    'oferta-el': ofertaEl,
    'oferta-el--fake': fakeofertaEl,
    'arrow-link': arrowLink,
    'loading': loadingView,
  },

}
</script>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/home/modulo-ofertas.vue